import { forwardRef, type Ref, type SVGProps } from "react";
const IconMovingTruckFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m28.13 15.067-3.195-4.632a1.86 1.86 0 0 0-1.622-.943H18.8V7.451a1.684 1.684 0 0 0-1.68-1.673H3.68A1.684 1.684 0 0 0 2 7.451v13.38c.003.621.352 1.19.906 1.476.238.128.504.195.774.196H4.8a3.726 3.726 0 0 0 3.735 3.718 3.726 3.726 0 0 0 3.734-3.718h8.4a3.72 3.72 0 0 0 3.731 3.714c2.06 0 3.73-1.662 3.73-3.714a1.87 1.87 0 0 0 1.866-1.812q.004-.024.004-.049v-3.714a1.87 1.87 0 0 0-1.87-1.86m-9.33-3.714h4.513l.082.132 2.265 3.279.206.303H18.8zM6.66 22.503c0 1.028.837 1.861 1.87 1.861a1.87 1.87 0 0 0 1.322-.544c.351-.349.548-.823.547-1.317a1.865 1.865 0 0 0-1.87-1.86 1.864 1.864 0 0 0-1.869 1.86m17.74 1.861a1.865 1.865 0 0 1-1.87-1.86c0-1.029.837-1.862 1.87-1.862 1.032 0 1.87.834 1.87 1.861a1.87 1.87 0 0 1-1.87 1.861M3.87 16.928h8.4a.933.933 0 0 0 .934-.93.933.933 0 0 0-.935-.93h-8.4z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMovingTruckFilledSVG);
ForwardRef.displayName = "IconMovingTruckFilled";
export { ForwardRef as IconMovingTruckFilled };
